import React, { FormEventHandler, useCallback, useState } from 'react';

import { Button, Card, CardContent, GridLegacy as Grid, TextField } from '@mui/material';

import { MmaoOffersSearchInput } from './utils';

const DEFAULT_SEARCH_INPUT: MmaoOffersSearchInput = {
  offerId: '',
  createdBy: '',
  updatedAtFrom: '',
  updatedAtTo: '',
};

interface Props {
  initialInput?: MmaoOffersSearchInput;
  onSubmit: (formObject: Record<string, string>) => void;
}

export default function MmaoOffersSearchForm({ initialInput, onSubmit }: Props) {
  const [offerId, setOfferId] = useState<string>(initialInput?.offerId ?? DEFAULT_SEARCH_INPUT.offerId);
  const [createdBy, setCreatedBy] = useState<string>(initialInput?.createdBy ?? DEFAULT_SEARCH_INPUT.createdBy);
  const [updatedAtFrom, setUpdatedAtFrom] = useState<string>(
    initialInput?.updatedAtFrom ?? DEFAULT_SEARCH_INPUT.updatedAtFrom,
  );
  const [updatedAtTo, setUpdatedAtTo] = useState<string>(initialInput?.updatedAtTo ?? DEFAULT_SEARCH_INPUT.updatedAtTo);

  const handleSubmit = useCallback<FormEventHandler<HTMLFormElement>>(
    (event) => {
      event.preventDefault();
      const formObject: Record<string, string> = {};
      if (offerId) formObject['offerId'] = offerId;
      if (createdBy) formObject['createdBy'] = createdBy;
      if (updatedAtFrom) formObject['updatedAtFrom'] = new Date(`${updatedAtFrom}T00:00:00.000Z`).toISOString();
      if (updatedAtTo) formObject['updatedAtTo'] = new Date(`${updatedAtTo}T23:59:59.999Z`).toISOString();
      onSubmit(formObject);
    },
    [offerId, createdBy, updatedAtFrom, updatedAtTo, onSubmit],
  );

  const handleReset = useCallback(() => {
    setOfferId(DEFAULT_SEARCH_INPUT.offerId);
    setCreatedBy(DEFAULT_SEARCH_INPUT.createdBy);
    setUpdatedAtFrom(DEFAULT_SEARCH_INPUT.updatedAtFrom);
    setUpdatedAtTo(DEFAULT_SEARCH_INPUT.updatedAtTo);
    onSubmit({});
  }, [onSubmit]);

  return (
    <Card>
      <CardContent>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2} alignItems="flex-end">
            <Grid item xs={12} sm={3}>
              <TextField
                label="Offer ID"
                value={offerId}
                onChange={(e) => setOfferId(e.target.value)}
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                label="Created By"
                placeholder="mmao-daily-sync"
                value={createdBy}
                onChange={(e) => setCreatedBy(e.target.value)}
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <TextField
                label="Updated At From"
                type="date"
                value={updatedAtFrom}
                onChange={(e) => setUpdatedAtFrom(e.target.value)}
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <TextField
                label="Updated At To"
                type="date"
                value={updatedAtTo}
                onChange={(e) => setUpdatedAtTo(e.target.value)}
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <Grid container spacing={1}>
                <Grid item>
                  <Button type="submit" variant="contained" size="small">
                    Search
                  </Button>
                </Grid>
                <Grid item>
                  <Button type="button" variant="text" size="small" onClick={handleReset}>
                    Reset
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </Card>
  );
}
